export const config = {
  API_URL: import.meta.env.VITE_API_URL || "https://chatbot.forinsia.com",
  AUTH_TOKEN: import.meta.env.VITE_AUTH_TOKEN || "gestor_formacao_token",
};

// Base URL to load widget assets (images) from — the widget's own <script>
// tag can be embedded on any third-party domain, so image paths must resolve
// against the widget's own host, not the embedding page's. Captured once at
// script load time in index.tsx (document.currentScript is only reliable
// synchronously during initial execution of a classic script).
let assetBaseUrl = "/ChatWidget/";
export function setAssetBaseUrl(scriptSrc: string | null | undefined) {
  if (scriptSrc) {
    assetBaseUrl = scriptSrc.replace(/[^/]*$/, "");
  }
}
export function getAssetBaseUrl() {
  return assetBaseUrl;
}